// projects/humanresources-personnel/src/assets/i18n/*/hr-per-personnel.json
export class HrPerPersonnelKey {
    private static readonly keyPrefix = 'hrPerPersonnel';
    public static pageHeader = `${HrPerPersonnelKey.keyPrefix}.pageHeader`;
    public static peopleNum = `${HrPerPersonnelKey.keyPrefix}.peopleNum`;
    public static identificationNumber = `${HrPerPersonnelKey.keyPrefix}.identificationNumber`;
    public static registryNumber = `${HrPerPersonnelKey.keyPrefix}.registryNumber`;
    public static title = `${HrPerPersonnelKey.keyPrefix}.title`;
    public static cadre = `${HrPerPersonnelKey.keyPrefix}.cadre`;
    public static employeeType = `${HrPerPersonnelKey.keyPrefix}.employeeType`;
    public static position = `${HrPerPersonnelKey.keyPrefix}.position`;
    public static peopleStatuses = `${HrPerPersonnelKey.keyPrefix}.peopleStatuses`;
    public static identitySerialNumber = `${HrPerPersonnelKey.keyPrefix}.identitySerialNumber`;
    public static employeeTypeUuid = `${HrPerPersonnelKey.keyPrefix}.employeeTypeUuid`;
    public static employeeSubtypeUuid = `${HrPerPersonnelKey.keyPrefix}.employeeSubtypeUuid`;
    public static workAreaUuid = `${HrPerPersonnelKey.keyPrefix}.workAreaUuid`;
    public static workSubareaUuid = `${HrPerPersonnelKey.keyPrefix}.workSubareaUuid`;
}
